import i18n from "../common/lang";
/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-11-12 11:48:25
 * @LastEditTime: 2022-03-24 18:22:21
 */
/**
 * 采集变量对象（表格或输入框中使用）
 */
// 采集变量寄存器类型
export const registerTypeObj = {
  // '0': 'Coils status',
  // '1': 'Discrete Inputs',
  // '3': 'Input Registers',
  // '4': 'Holding Registers'
  '1': i18n.t('lang.unit.registerTypeObj1'),
  '2': i18n.t('lang.unit.registerTypeObj2'),
  '3': i18n.t('lang.unit.registerTypeObj3'),
  '4': i18n.t('lang.unit.registerTypeObj4')
}

// 采集变量类型
export const dataFormatObj = {
  '1': i18n.t('lang.unit.dataFormatObj1'),
  '2': i18n.t('lang.unit.dataFormatObj2'),
  '3': i18n.t('lang.unit.dataFormatObj3'),
  '4': i18n.t('lang.unit.dataFormatObj4'),
  '5': i18n.t('lang.unit.dataFormatObj5'),
  '6': i18n.t('lang.unit.dataFormatObj6'),
  '7': i18n.t('lang.unit.dataFormatObj7'),
  '8': i18n.t('lang.unit.dataFormatObj8'),
  '9': i18n.t('lang.unit.dataFormatObj9'),
  '10': i18n.t('lang.unit.dataFormatObj10'),
  '11': i18n.t('lang.unit.dataFormatObj11'),
  '12': i18n.t('lang.unit.dataFormatObj12'),
  '13': i18n.t('lang.unit.dataFormatObj13'),
  '14': i18n.t('lang.unit.dataFormatObj14'),
  '15': i18n.t('lang.unit.dataFormatObj15'),
}
export const ioControlListObj = {
  '0': i18n.t('lang.unit.ioControlListObj0'),
  '1': i18n.t('lang.unit.ioControlListObj1'),
  '2': i18n.t('lang.unit.ioControlListObj2'),
  '3': i18n.t('lang.unit.ioControlListObj3'),
}
export const modbusListObj = {
  '0': i18n.t('lang.unit.modbusListObj0'),
  '1': i18n.t('lang.unit.modbusListObj1'),
  '2': i18n.t('lang.unit.modbusListObj2'),
}
export const typeListObj = {
  '0': i18n.t("lang.unit.typeListObj0"),
  '1': i18n.t("lang.unit.typeListObj1"),
}
// 数据类型对象
export const dataTypeObj = {
  // '1': 'int16',
  // '2': 'uint16',
  // '3': 'int32',
  // '4': 'uint32',
  // '5': 'int64',
  // '6': 'uint64',
  // '7': 'float',
  // '8': 'double',
  // '9': 'string',
  // '10': 'bool',
  // '11': 'custom',
  '1': i18n.t('lang.unit.dataTypeObj1'),
  '2': i18n.t('lang.unit.dataTypeObj2'),
  '3': i18n.t('lang.unit.dataTypeObj3'),
  '4': i18n.t('lang.unit.dataTypeObj4'),
  '5': i18n.t('lang.unit.dataTypeObj5'),
  '6': i18n.t('lang.unit.dataTypeObj6'),
  '7': i18n.t('lang.unit.dataTypeObj7'),
  '8': i18n.t('lang.unit.dataTypeObj8'),
  '9': i18n.t('lang.unit.dataTypeObj9'),
  '10': i18n.t('lang.unit.dataTypeObj10'),
  // '11': i18n.t('lang.unit.dataTypeObj11'),
  '12': i18n.t('lang.unit.dataTypeObj12'),
}

// 字节序对象
export const endianObj = {
  '1': i18n.t('lang.unit.endianObj1'),
  '2': i18n.t('lang.unit.endianObj2')
}
// 上报类型对象
export const triggerObj = {
  // '1': 'once',
  // '2': 'cycle',
  // '4': 'never',
  // '1': '仅一次',
  '2': i18n.t('lang.unit.triggerObj2'),
  '3': i18n.t('lang.unit.triggerObj3'),
  '4': i18n.t('lang.unit.triggerObj4'),
}
// 寄存方式
export const storageModeObj = {
  '1': i18n.t("lang.unit.storageModeObj1"),
  '2': i18n.t("lang.unit.storageModeObj2")
}

// 读写方式
export const rorwObj = {
  '1': i18n.t("lang.unit.rorwObj1"),
  '2': i18n.t("lang.unit.rorwObj2")
}

// 变量单位对象
export const unitObj = {
  '1': i18n.t("lang.unit.unitObj1"),
  '2': i18n.t("lang.unit.unitObj2"),
  '3': i18n.t("lang.unit.unitObj3"),
  '4': i18n.t("lang.unit.unitObj4"),
  '5': i18n.t("lang.unit.unitObj5"),
  '6': i18n.t("lang.unit.unitObj6"),
  '7': i18n.t("lang.unit.unitObj7"),
}
/**
 * 采集变量数组（下拉框使用）
 */
// 寄存器类型选项
export const registerTypeOptions = [
  // { label: '0(Coils status)', value: 0 },
  // { label: '1(Discrete Inputs)', value: 1 },
  // { label: '3(Input Registers)', value: 3 },
  // { label: '4(Holding Registers)', value: 4 },
  { label: i18n.t('lang.unit.registerTypeOptions1'), value: 1 },
  { label: i18n.t('lang.unit.registerTypeOptions2'), value: 2 },
  { label: i18n.t('lang.unit.registerTypeOptions3'), value: 3 },
  { label: i18n.t('lang.unit.registerTypeOptions4'), value: 4 },
]

// 变量类型选项
export const dataFormateOptions = [
  { label: i18n.t('lang.unit.dataFormatObj1'), value: 1 },
  { label: i18n.t('lang.unit.dataFormatObj2'), value: 2 },
  { label: i18n.t('lang.unit.dataFormatObj3'), value: 3 },
  { label: i18n.t('lang.unit.dataFormatObj4'), value: 4 },
  { label: i18n.t('lang.unit.dataFormatObj5'), value: 5 },
  { label: i18n.t('lang.unit.dataFormatObj6'), value: 6 },
  { label: i18n.t('lang.unit.dataFormatObj7'), value: 7 },
  { label: i18n.t('lang.unit.dataFormatObj8'), value: 8 },
  { label: i18n.t('lang.unit.dataFormatObj9'), value: 9 },
  { label: i18n.t('lang.unit.dataFormatObj10'), value: 10 },
  { label: i18n.t('lang.unit.dataFormatObj11'), value: 11 },
  { label: i18n.t('lang.unit.dataFormatObj12'), value: 12 },
  { label: i18n.t('lang.unit.dataFormatObj13'), value: 13 },
  { label: i18n.t('lang.unit.dataFormatObj14'), value: 14 },
  { label: i18n.t('lang.unit.dataFormatObj15'), value: 15 },
]

// 数据类型数组
export const dataTypeOptions = [
  // { label: 'int16', value: 1},
  // { label: 'uint16', value: 2},
  // { label: 'int32', value: 3},
  // { label: 'uint32', value: 4},
  // { label: 'int64', value: 5},
  // { label: 'uint64', value: 6},
  // { label: 'float', value: 7},
  // { label: 'double', value: 8},
  // { label: 'string', value: 9},
  // // { label: 'bool', value: 10},
  // { label: 'custom', value: 11},
  { label: i18n.t("lang.unit.dataTypeObj1"), value: 1 },
  { label: i18n.t("lang.unit.dataTypeObj2"), value: 2 },
  { label: i18n.t("lang.unit.dataTypeObj3"), value: 3 },
  { label: i18n.t("lang.unit.dataTypeObj4"), value: 4 },
  { label: i18n.t("lang.unit.dataTypeObj5"), value: 5 },
  { label: i18n.t("lang.unit.dataTypeObj6"), value: 6 },
  { label: i18n.t("lang.unit.dataTypeObj7"), value: 7 },
  { label: i18n.t("lang.unit.dataTypeObj8"), value: 8 },
  { label: i18n.t("lang.unit.dataTypeObj9"), value: 9 },
  { label: i18n.t("lang.unit.dataTypeObj10"), value: 10 },
  // { label: i18n.t("lang.unit.dataTypeObj11"), value: 11 },
  { label: i18n.t("lang.unit.dataTypeObj12"), value: 12 },
]
// 字节序数组
export const endianOptions = [
  { label: i18n.t("lang.unit.endianObj1"), value: 1 },
  { label: i18n.t("lang.unit.endianObj2"), value: 2 },
]
// 上报类型数组
export const triggerOptions = [
  // { label: '仅一次', value: 1 },
  { label: i18n.t('lang.unit.triggerObj2'), value: 2 },
  { label: i18n.t('lang.unit.triggerObj3'), value: 3 },
  { label: i18n.t('lang.unit.triggerObj4'), value: 4 },
]

// 变量单位数组
export const unitOptions = [
  { label: i18n.t("lang.unit.unitObj1"), value: 1 },
  { label: i18n.t("lang.unit.unitObj2"), value: 2 },
  { label: i18n.t("lang.unit.unitObj3"), value: 3 },
  { label: i18n.t("lang.unit.unitObj4"), value: 4 },
  { label: i18n.t("lang.unit.unitObj5"), value: 5 },
  { label: i18n.t("lang.unit.unitObj6"), value: 6 },
  { label: i18n.t("lang.unit.unitObj7"), value: 7 },
  { label: i18n.t("lang.ConfigSetting.custom"), value: '自定义' },
]

// 上报周期数组
export const intervalOptions = [
  { label: '10', value: '10' },
  { label: '15', value: '15' },
  { label: '20', value: '20' },
  { label: '30', value: '30' },
  { label: '60', value: '60' },
  { label: i18n.t("lang.ConfigSetting.custom"), value: '自定义' },
]
//ioControl功能选项
export const ioControlListOptions = [
  { label: i18n.t("lang.unit.ioControlListObj0"), value: '0' },
  { label: i18n.t("lang.unit.ioControlListObj1"), value: '1' },
  { label: i18n.t("lang.unit.ioControlListObj2"), value: '2' },
  { label: i18n.t("lang.unit.ioControlListObj3"), value: '3' },
]
//modbus功能选项
export const modbusListOptions = [
  { label: i18n.t("lang.unit.modbusListObj0"), value: '0' },
  { label: i18n.t("lang.unit.modbusListObj1"), value: '1' },
  { label: i18n.t("lang.unit.modbusListObj2"), value: '2' },
]
//模板类别
export const typeListOptions = [
  {
    value: '0', label: 'Modbus',

  }, {
    value: '1', label: i18n.t('lang.particulars.IOControl'),
  }
]
export const ioTypeObj = {
  '0': i18n.t('lang.IOControl.relay'),
  '1': 'DI',
  '2': 'DO'
}
export const ioTypeOptions = [
  { label: i18n.t('lang.IOControl.relay'), value: '0' },
  { label: 'DI', value: '1' },
  { label: 'DO', value: '2' }
]
export const ioStateObj = {
  '0': i18n.t('lang.openvpn.open'),
  '1': i18n.t('lang.openvpn.close')
}
//io状态
export const ioStateOptions = [
  { label: i18n.t('lang.openvpn.open'), value: '0' },
  { label: i18n.t('lang.openvpn.close'), value: '1' }
]
export const ioNumberOptions = [
  { label: '1', value: '1' },
  { label: '2', value: '2' }
]